// extracted by mini-css-extract-plugin
module.exports = {"container":"Warning_container_O7ea_","text":"Warning_text_KSEDl"};